/**
 * Check all courses to find the right one
 */

import { fetchCourses } from '../services/courseService';
import { getCourseById } from '../services/courseService';

export async function checkAllCourses() {
  console.log('🔍 CHECKING ALL COURSES');
  console.log('=' .repeat(50));
  
  try {
    // Get all courses
    let coursesResponse = await fetchCourses();
    
    // Handle the response wrapper
    if (coursesResponse && coursesResponse.response) {
      coursesResponse = await coursesResponse.response;
    }
    if (coursesResponse && typeof coursesResponse.json === 'function') {
      coursesResponse = await coursesResponse.json();
    }
    if (coursesResponse && typeof coursesResponse.body === 'string') {
      coursesResponse = JSON.parse(coursesResponse.body);
    }
    
    // Extract courses array
    let courses = coursesResponse;
    if (coursesResponse && coursesResponse.courses) {
      courses = coursesResponse.courses;
    }
    
    // Ensure it's an array
    if (!Array.isArray(courses)) {
      console.log('Response is not an array:', coursesResponse);
      courses = [];
    }
    
    console.log(`\n📚 Found ${courses.length} courses:\n`);
    
    for (const course of courses) {
      console.log(`Course: ${course.title}`);
      console.log(`  ID: ${course.courseId || course.id}`);
      console.log(`  Status: ${course.status}`);
      console.log(`  Available: ${course.availableSpots}`);
      console.log(`  Start: ${course.startDate}`);
      console.log('');
    }
    
    // Now check the specific course we're testing
    const TEST_COURSE_ID = '045ef510-0d3d-41f7-808e-e75a77cb765c';
    console.log(`\n🎯 CHECKING TEST COURSE: ${TEST_COURSE_ID}`);
    console.log('-'.repeat(50));
    
    try {
      const testCourse = await getCourseById(TEST_COURSE_ID);
      console.log('Test course found:');
      console.log('  Title:', testCourse.title);
      console.log('  Status:', testCourse.status);
      console.log('  Status (JSON):', JSON.stringify(testCourse.status));
      console.log('  Available:', testCourse.availableSpots);
    } catch (err) {
      console.log('❌ Test course not found or error:', err.message);
    }
    
    // Find AugustShort2025
    console.log('\n🔍 LOOKING FOR AugustShort2025...');
    const augustCourse = courses.find(c => 
      c.title && c.title.includes('August') || 
      c.title && c.title.includes('AugustShort')
    );
    
    if (augustCourse) {
      console.log('Found August course:');
      console.log('  Title:', augustCourse.title);
      console.log('  ID:', augustCourse.courseId || augustCourse.id);
      console.log('  Status:', augustCourse.status);
      console.log('  Available:', augustCourse.availableSpots);
      
      // Get full details
      const fullAugust = await getCourseById(augustCourse.courseId || augustCourse.id);
      console.log('\nFull details:');
      console.log('  Status from getCourseById:', fullAugust.status);
      console.log('  Status (JSON):', JSON.stringify(fullAugust.status));
    }
    
    // Find July 30 course
    console.log('\n🔍 LOOKING FOR July 30 course...');
    const julyCourse = courses.find(c => 
      c.title && c.title.includes('July') || 
      c.title && c.title === 'July 30'
    );
    
    if (julyCourse) {
      console.log('Found July course:');
      console.log('  Title:', julyCourse.title);
      console.log('  ID:', julyCourse.courseId || julyCourse.id);
      console.log('  Status:', julyCourse.status);
      console.log('  Available:', julyCourse.availableSpots);
      
      // Get full details
      const fullJuly = await getCourseById(julyCourse.courseId || julyCourse.id);
      console.log('\nFull details:');
      console.log('  Status from getCourseById:', fullJuly.status);
      console.log('  Status (JSON):', JSON.stringify(fullJuly.status));
    }
    
    return courses;
    
  } catch (error) {
    console.error('Check failed:', error);
  }
}

window.checkAllCourses = checkAllCourses;